export enum TransactionType {
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
}
